import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Tooltip from '@components/Tooltip'

class ExpertBadge extends Component {
  static propTypes = {
    badgeId: PropTypes.number
  }

  renderBadge () {
    switch (this.props.badgeId) {
      case 1:
        return this.wrapTooltip(
          'Platinum - One of the top 1% of Experts',
          <Platinum />
        )
      case 2:
        return this.wrapTooltip('Gold - One of the top 5% of Experts', <Gold />)
      case 3:
        return this.wrapTooltip(
          'Silver - One of the top 10% of Experts',
          <Silver />
        )
      default:
        return ''
    }
  }

  wrapTooltip = (text, badge) => {
    return (
      <Tooltip tooltip={text}>
        <div className='ExpertBadge__wrapper'>{badge}</div>
      </Tooltip>
    )
  }

  render () {
    return <div className='ExpertBadge'>{this.renderBadge()}</div>
  }
}

const Gold = () => {
  return (
    <svg width='22px' height='22px' viewBox='0 0 22 22' version='1.1'>
      <g
        id='icons'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g transform='translate(-125.000000, -465.000000)' id='gold'>
          <g transform='translate(125.000000, 465.000000)'>
            <g id='Group-2'>
              <polygon
                id='Page-1'
                fill='#F0C57E'
                points='13.9477264 -4.5552521e-05 11.0002505 2.07783269 8.05277467 -4.5552521e-05 6.53906439 3.27313085 2.94747587 2.94720256 3.2731764 6.53879108 0 8.05250135 2.07787825 10.9999772 0 13.9474531 3.2731764 15.4609356 2.94747587 19.0525241 6.53906439 18.7265958 8.05277467 22 11.0002505 19.921894 13.9477264 22 15.4614367 18.7265958 19.0527974 19.0525241 18.7268692 15.4609356 22.0002733 13.9474531 19.9221673 10.9999772 22.0002733 8.05250135 18.7268692 6.53879108 19.0527974 2.94720256 15.4614367 3.27313085'
              />
              <path
                d='M10.9692383,10.590332 L14.0844727,10.590332 L14.0844727,14.6616211 C13.5795873,14.8263355 13.1042503,14.9418128 12.6584473,15.0080566 C12.2126443,15.0743005 11.757001,15.1074219 11.2915039,15.1074219 C10.1062766,15.1074219 9.20125638,14.7591994 8.57641602,14.0627441 C7.95157565,13.3662888 7.63916016,12.3663802 7.63916016,11.0629883 C7.63916016,9.79540382 8.00170536,8.80713245 8.72680664,8.09814453 C9.45190792,7.38915661 10.4571876,7.03466797 11.7426758,7.03466797 C12.5483439,7.03466797 13.3253543,7.19579917 14.0737305,7.51806641 L13.5205078,8.85009766 C12.9475883,8.56363789 12.3514028,8.42041016 11.7319336,8.42041016 C11.0122034,8.42041016 10.4357118,8.66210696 10.0024414,9.14550781 C9.56917101,9.62890867 9.35253906,10.2788045 9.35253906,11.0952148 C9.35253906,11.9474326 9.52709786,12.5982237 9.8762207,13.0476074 C10.2253435,13.4969912 10.7329068,13.7216797 11.3989258,13.7216797 C11.7462582,13.7216797 12.0989565,13.6858728 12.4570312,13.6142578 L12.4570312,11.9760742 L10.9692383,11.9760742 L10.9692383,10.590332 Z'
                id='G'
                fill='#000000'
                opacity='0.495277519'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

const Silver = () => {
  return (
    <svg width='22px' height='22px' viewBox='0 0 22 22' version='1.1'>
      <g
        id='icons'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g transform='translate(-182.000000, -465.000000)' id='silver'>
          <g transform='translate(182.000000, 465.000000)'>
            <polygon
              id='Page-1'
              fill='#C9CDD3'
              points='13.9476542 6.83284278e-05 11.0001936 2.07793582 8.05273298 6.83284278e-05 6.53903054 3.27322778 2.94746062 2.94730118 3.27315945 6.53887111 0 8.05257355 2.07786749 11.0000342 0 13.9474948 3.27315945 15.4609695 2.94746062 19.0525394 6.53903054 18.7266128 8.05273298 22 11.0001936 19.9219047 13.9476542 22 15.4613567 18.7266128 19.0526988 19.0525394 18.7267722 15.4609695 22.0001594 13.9474948 19.9220642 11.0000342 22.0001594 8.05257355 18.7267722 6.53887111 19.0526988 2.94730118 15.4613567 3.27322778'
            />
            <path
              d='M13.6235352,12.8193359 C13.6235352,13.5283239 13.3684108,14.086912 12.8581543,14.4951172 C12.3478978,14.9033224 11.6380254,15.1074219 10.7285156,15.1074219 C9.89062081,15.1074219 9.14941729,14.9498714 8.50488281,14.6347656 L8.50488281,13.0878906 C9.03483338,13.3242199 9.48331522,13.4907222 9.8503418,13.5874023 C10.2173684,13.6840825 10.5530584,13.7324219 10.8574219,13.7324219 C11.2226581,13.7324219 11.5028473,13.6625984 11.697998,13.5229492 C11.8931488,13.3833001 11.9907227,13.1756199 11.9907227,12.8999023 C11.9907227,12.7459302 11.9477543,12.6089687 11.8618164,12.4890137 C11.7758785,12.3690586 11.649659,12.2535813 11.4831543,12.1425781 C11.3166496,12.031575 10.9773789,11.8543306 10.465332,11.6108398 C9.98551192,11.3852528 9.62565224,11.1686208 9.38574219,10.9609375 C9.14583213,10.7532542 8.95426504,10.5115574 8.81103516,10.2358398 C8.66780527,9.96012232 8.59619141,9.63785992 8.59619141,9.26904297 C8.59619141,8.57437804 8.83162199,8.0283223 9.30249023,7.63085938 C9.77335847,7.23339645 10.4241495,7.03466797 11.2548828,7.03466797 C11.663088,7.03466797 12.0524884,7.08300733 12.4230957,7.1796875 C12.793703,7.27636767 13.1813131,7.41243402 13.5859375,7.58789062 L13.0488281,8.88232422 C12.6298807,8.71044836 12.2834486,8.59049513 12.0095215,8.52246094 C11.7355943,8.45442674 11.4661472,8.42041016 11.2011719,8.42041016 C10.8860661,8.42041016 10.6443693,8.49381437 10.4760742,8.640625 C10.3077791,8.78743563 10.2236328,8.97900272 10.2236328,9.21533203 C10.2236328,9.36214266 10.2576494,9.49015245 10.3256836,9.59936523 C10.3937178,9.70857802 10.5020338,9.81420847 10.6506348,9.91625977 C10.7992358,10.0183111 11.1510389,10.2018216 11.7060547,10.4667969 C12.4401078,10.8177101 12.9431953,11.1695132 13.215332,11.5222168 C13.4874688,11.8749204 13.6235352,12.3072891 13.6235352,12.8193359 L13.6235352,12.8193359 Z'
              id='S'
              fill='#000000'
              opacity='0.501282649'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

const Platinum = () => {
  return (
    <svg width='22px' height='22px' viewBox='0 0 22 22' version='1.1'>
      <g
        id='icons'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g transform='translate(-68.000000, -465.000000)' id='platinum'>
          <g transform='translate(68.000000, 465.000000)'>
            <polygon
              id='Page-1'
              fill='#B6CAE4'
              points='13.9477264 -4.5552521e-05 11.0002505 2.07783269 8.05277467 -4.5552521e-05 6.53906439 3.27313085 2.94747587 2.94720256 3.2731764 6.53879108 0 8.05250135 2.07787825 10.9999772 0 13.9474531 3.2731764 15.4609356 2.94747587 19.0525241 6.53906439 18.7265958 8.05277467 22 11.0002505 19.921894 13.9477264 22 15.4614367 18.7265958 19.0527974 19.0525241 18.7268692 15.4609356 22.0002733 13.9474531 19.9221673 10.9999772 22.0002733 8.05250135 18.7268692 6.53879108 19.0527974 2.94720256 15.4614367 3.27313085'
            />
            <path
              d='M10.6533203,10.8427734 L11.2011719,10.8427734 C11.7132187,10.8427734 12.0963529,10.7416189 12.3505859,10.5393066 C12.604819,10.3369944 12.7319336,10.0424824 12.7319336,9.65576172 C12.7319336,9.26546029 12.625408,8.97721447 12.4123535,8.79101562 C12.1992991,8.60481678 11.8653994,8.51171875 11.4106445,8.51171875 L10.6533203,8.51171875 L10.6533203,10.8427734 Z M14.4130859,9.59667969 C14.4130859,10.441736 14.1490098,11.0880511 13.6208496,11.5356445 C13.0926894,11.9832379 12.341639,12.2070312 11.3676758,12.2070312 L10.6533203,12.2070312 L10.6533203,15 L8.98828125,15 L8.98828125,7.14746094 L11.496582,7.14746094 C12.4490608,7.14746094 13.173256,7.35245563 13.6691895,7.76245117 C14.1651229,8.17244671 14.4130859,8.7838501 14.4130859,9.59667969 L14.4130859,9.59667969 Z'
              id='P'
              fill='#000000'
              opacity='0.491546175'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ExpertBadge
